import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, AppBar, IconButton } from 'material-ui';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import DocumentTitle from 'react-document-title';
import { ActionHelp, NavigationChevronLeft } from 'material-ui/svg-icons';
import { withRouter } from 'react-router';

import NavigationMenu from './NavigationMenu';
import ChatCounter from './ChatCounter';
import StatusBarStyle from './StatusBarStyle';
import settings from '../config/settings';
import RemoteLink from './RemoteLink';
import { Features } from '../utils';

const styles = {
  appBar: {
    position: 'fixed',
    top: '0',
    padding: '0 16px',
    backgroundColor: '#041e2b',
  },
  pageWrapper: {
    marginTop: '48px',
  },
  menuIconLeft: {
    margin: '0 0 0 -16px',
  },
  menuIconRight: {
    margin: '0 -16px 0 0',
  },
  title: {
    lineHeight: '48px',
    height: '48px',
    fontSize: '16px',
    fontWeight: '500',
  },
  wrapper: {
    marginTop: '-48px',
  },
  counter: {
    display: 'block',
    position: 'absolute',
    backgroundColor: 'rgb(195, 31, 59)',
    width: 22,
    height: 22,
    top: 4,
    right: 4,
    color: 'white',
    fontSize: 12,
    lineHeight: '22px',
    fontWeight: 'bold',
    borderRadius: 11,
  },
};

const BurgerWithCounter = props => (
  <IconButton {...props}>
    <MenuIcon color="white" />
    <Features has="chat">
      <ChatCounter type="total" customStyle={styles.counter} />
    </Features>
  </IconButton>
);

class Screen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false,
    };
  }

  render() {
    const {
      title,
      helpUrl,
      children,
      zDepth,
      offset,
      iconElementRight,
      onRightIconButtonClick,
      backUrl,
      router: {
        history,
      },
    } = this.props;

    const getHelpElem = () => {
      const href = `${settings.helpUrl}${helpUrl}`;

      if (!helpUrl) {
        return null;
      }

      return (
        <RemoteLink href={href}>
          <IconButton>
            <ActionHelp color="white" />
          </IconButton>
        </RemoteLink>
      );
    };

    const getRightElement = () => iconElementRight || getHelpElem();

    const BackButton = () => (
      <IconButton onClick={() => history.push(backUrl)}>
        <NavigationChevronLeft color="white" />
        <ChatCounter type="total" customStyle={styles.counter} />
      </IconButton>
    );

    return (
      <div style={styles.wrapper}>
        <StatusBarStyle color={styles.appBar.backgroundColor} barStyle="light-content" />
        <DocumentTitle title={title} />
        <AppBar
          style={styles.appBar}
          iconStyleLeft={styles.menuIconLeft}
          iconStyleRight={styles.menuIconRight}
          titleStyle={styles.title}
          iconElementLeft={backUrl ? <BackButton /> : <BurgerWithCounter />}
          iconElementRight={getRightElement()}
          onLeftIconButtonClick={() => this.setState({ isDrawerOpen: true })}
          onRightIconButtonClick={onRightIconButtonClick}
          title={title}
          zDepth={zDepth}
        />
        <div style={styles.pageWrapper}>
          <div style={{ paddingTop: offset }}>
            {children}
          </div>
        </div>
        <Drawer
          docked={false}
          onRequestChange={isDrawerOpen => this.setState({ isDrawerOpen })}
          open={this.state.isDrawerOpen}
        >
          <NavigationMenu onNavigate={() => this.setState({ isDrawerOpen: false })} />
        </Drawer>
      </div>
    );
  }
}

Screen.propTypes = {
  title: PropTypes.string,
  helpUrl: PropTypes.string,
  children: PropTypes.node,
  zDepth: PropTypes.number,
  offset: PropTypes.number,
  iconElementRight: PropTypes.node,
  onRightIconButtonClick: PropTypes.func,
  backUrl: PropTypes.string,
  router: PropTypes.shape({}),
};

Screen.defaultProps = {
  statusBar: {
    color: '#041e2b',
    style: 'light-content',
  },
  zDepth: 1,
  offset: 0,
};

export default withRouter(Screen);



// WEBPACK FOOTER //
// ./src/components/Screen.js